/* eslint-disable */

import React, { Component } from 'react';
import { Dropdown, Input, Divider, Button } from 'semantic-ui-react';
import _ from 'lodash';

import './ModalDuplicatePackage.css';

class ModalDuplicatePackage extends Component {
  state = {
    packageName: `${this.props.packageToDuplicate.name} - Copy`
  };

  handleFormChange = (event, { value }) => {
    this.setState({ packageName: value });
  };

  duplicatePackage = () => {
    this.props.duplicatePackage(
      this.props.packageToDuplicate,
      this.state.packageName
    );
  };

  closeDuplicatePackageModal = () => {
    this.props.onCloseDuplicatePackageModal();
  };

  render() {
    const { packageToDuplicate } = this.props;
    return (
      <div className="modal-duplicate-container">
        <span>Duplicating {packageToDuplicate.name}</span>
        <Divider hidden />
        <Input
          placeholder="Output Name"
          type="text"
          name="packageName"
          value={this.state.packageName}
          onChange={this.handleFormChange}
        />
        <Divider hidden />
        <Button
          onClick={this.closeDuplicatePackageModal}
          size="small"
          color="grey"
        >
          Cancel
        </Button>
        <Button onClick={this.duplicatePackage} size="small" color="blue">
          Duplicate
        </Button>
      </div>
    );
  }
}

export default ModalDuplicatePackage;



// WEBPACK FOOTER //
// ./src/screens/PackageBuilder/ModalDuplicatePackage.js